import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "logo-home" }, [
      /*#__PURE__*/_createElementVNode("a", { title: "GroupTrips.com" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: "/img/logo.png",
          alt: "GroupTrips.com"
        })
      ])
    ])
  ])
], -1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "container-inner" }
const _hoisted_4 = { class: "wide554" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/CMS/img/spacer.gif",
    alt: "",
    width: "1",
    height: "130"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "title-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/CMS/img/icn-login.gif",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createTextVNode(" User Login ")
], -1)
const _hoisted_7 = { class: "box-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "   ", -1)
const _hoisted_9 = {
  width: "95%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "tbl-1",
  align: "center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { width: "29%" }, " EMAIL ADDRESS ", -1)
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { width: "29%" }, " PASSWORD ", -1)
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { width: "29%" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "RememberMe" }, "Remember Me", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, "   ", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "btn btn-secondary"
}, "GO BACK", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "2",
    align: "right",
    class: "txt-13"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/CMS/ForgotPassword",
      title: "Click here to recover Password"
    }, "Forgot Password?")
  ])
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "   ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalLoading = _resolveComponent("ModalLoading")!
  const _component_ModalErrorMessage = _resolveComponent("ModalErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    maxlength: "100",
                    id: "email",
                    size: "30",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Email') }]),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["enter"])),
                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Email')
                  }, null, 42, _hoisted_11), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    maxlength: "25",
                    id: "password",
                    size: "30",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                    class: _normalizeClass(["form-control", { 'field-error': _ctx.hasFieldError(_ctx.fieldErrors, 'Password') }]),
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)), ["enter"])),
                    title: _ctx.getFieldErrorMsg(_ctx.fieldErrors, 'Password')
                  }, null, 42, _hoisted_13), [
                    [_vModelText, _ctx.password]
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    checked: "checked",
                    id: "RemembderMe",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.remember) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.remember]
                  ]),
                  _hoisted_15,
                  _hoisted_16
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)))
                  }, "LOGIN"),
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dtExternalLogin && _ctx.dtExternalLogin(...args)))
                  }, "DTExternal Login")
                ])
              ]),
              _hoisted_21
            ]),
            _hoisted_22
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ModalLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.errorMessage != null)
      ? (_openBlock(), _createBlock(_component_ModalErrorMessage, {
          key: 1,
          message: _ctx.errorMessage,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.errorMessage = null))
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}